import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { skipWhile } from 'rxjs/operators';
import { isCanvasRendererHost } from 'src/app/canvas-renderer/canvas-renderer-host';
import * as AppSelectors from 'src/app/state/app/app.selectors';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private store: Store) { }

  loaded$ = this.store.select(AppSelectors.loaded);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.handle(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.handle(state.url);
  }

  private handle(url: string) {
    if (environment.testing || isCanvasRendererHost) {
      return true;
    }
    
    return this.loaded$.pipe(
      skipWhile(b => !b)
    );
  }
}
